export interface IValueForDateCompareExtractable {
  extractValueForDateCompare(): number;
}

export function instanceOfIValueForDateCompareExtractable(instance: any): instance is IValueForDateCompareExtractable {
  if (!instance) { return false; }
  return (instance.extractValueForDateCompare !== undefined);
}
